<template>
  <div class="drawer-handles" :class="{open: isOpen}">
    <button @click="$emit('open', 'menu')">
      <i class="material-icons open-item">menu</i>
    </button>
    <button @click="$emit('open', 'notepad')">
      <i class="material-icons open-item">assignment</i>
    </button>
    <button @click="$emit('open', 'chat')" v-if="scenarioId">
      <i class="material-icons open-item">question_answer</i>
    </button>
  </div>
</template>

<script>

export default {
  name: "DrawerHandles",
  data () {
    return {
      isOpen: false
    }
  },
  computed: {
    scenarioId () {
      return this.$route.params.scenarioId
    }
  }
};
</script>

<style lang="scss" scoped>
.drawer-handles {
  position: absolute;  
  z-index: 400;
  top: 30px;
  left: 0;
  width: 45px;
  
  display: flex;
  flex-direction: row;

  button {
    color: #fff;
    margin-bottom: 1em;
  }

  @media all and (min-width: 1024px) {
   flex-direction: column;
  }
}
</style>